import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=40d70910&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=js"
export * from "./activityList.vue?vue&type=script&lang=js"
import style0 from "./activityList.vue?vue&type=style&index=0&id=40d70910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d70910",
  null
  
)

component.options.__file = "activityList.vue"
export default component.exports